import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d7a797d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "server-detail",
  ref: "serverDetail"
}
const _hoisted_2 = {
  key: 0,
  class: "title-tip"
}
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-title" }, "极飞科技", -1))
const _hoisted_5 = { class: "item-one-content" }
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "num" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-title" }, "服务内容", -1))
const _hoisted_12 = { class: "item-two-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "num" }, "01"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-content-inner" }, "产品检查")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "num" }, "02"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-content-inner" }, "产品介绍")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "num" }, "03"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-content-inner" }, "安全操作宣讲")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "num" }, "04"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-content-inner" }, "设备启用")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "num" }, "05"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-content-inner" }, "实操演示")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "num" }, "06"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-content-inner" }, "维护保养宣讲")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "num" }, "07"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-content-inner" }, "售后服务指引")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "num" }, "08"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-content-inner" }, "培训路径指引")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_29 = {
  key: 0,
  class: "item"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-title" }, "交付清单", -1))
const _hoisted_31 = { class: "item-three-content" }
const _hoisted_32 = ["src", "onClick"]
const _hoisted_33 = { class: "item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-title" }, "单据信息", -1))
const _hoisted_35 = { class: "item-four-content" }
const _hoisted_36 = { class: "item-four-content-item" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "服务单号", -1))
const _hoisted_38 = { class: "value" }
const _hoisted_39 = { class: "item-four-content-item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "创建时间", -1))
const _hoisted_41 = { class: "value" }
const _hoisted_42 = {
  key: 0,
  class: "item-four-content-item"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "完成时间", -1))
const _hoisted_44 = { class: "value" }
const _hoisted_45 = {
  key: 0,
  class: "operator xag-page__footer"
}

import AppHeader from '@/components/Header.vue'
import { getTicketDetail, confirmOrder } from '@/apis/complete-machine-delivery'
import appHost from '@/utils/app'
import { commonErrorHandle } from '@/utils/error-handle'
import { useRouter, useRoute } from 'vue-router'
import { ref, onBeforeMount, computed } from 'vue'
import { Steps, Step, Button, ImagePreview, Toast, Dialog } from 'vant'
import { statusInfoMap, detailStatusTextMap } from '@/defination/complete-machine-delivery'


export default /*#__PURE__*/_defineComponent({
  __name: 'delivery-service-detail-v1',
  setup(__props) {

const Router = useRouter()
const Route = useRoute()
let imagePreviewShow = ref(false)

let detail = ref({
  title: '',
  titleTip: '请耐心等待工作人员联系',
  status: -1,
  titleColor: '',
  headerInfo: [],
  deliver_info: {
    img: [],
  },
  orderInfo: {
    sn: '',
    creatTime: '',
    finishTime: '',
    is_assess_auth: false,
  },
  hasAssessInfo: false,
  currentImg: [],
})

let isShowDeliverInfo = computed(() => {
  return [30, 40].includes(detail.value.status)
})

let isShowFinishTime = computed(() => {
  return [40, 50].includes(detail.value.status)
})
let isShowFinish = computed(() => {
  return detail.value.status == 30
})
let isShowEvaluation = computed(() => {
  return (
    [40].includes(detail.value.status) &&
    !detail.value.hasAssessInfo &&
    detail.value.orderInfo.is_assess_auth
  )
})
let isShowViewEvaluation = computed(() => {
  return [40].includes(detail.value.status) && detail.value.hasAssessInfo
})
let isShowOperator = computed(() => {
  return isShowFinish.value || isShowEvaluation.value || isShowViewEvaluation.value
})
let isShowTitleTip = computed(() => {
  return [0, 10, 20, 50].includes(detail.value.status)
})

function showImg(type: string, index: number, img?: Array<string>) {
  if (type === 'header') {
    console.log('showImg', index)
    ImagePreview({
      images: img,
    })
  } else {
    ImagePreview({
      images: detail.value.currentImg,
      startPosition: index,
    })
  }
}
async function initData() {
  try {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0,
    })
    let data = await getTicketDetail({
      order_no: Route.query.order_no as string,
    })
    detail.value.title = detailStatusTextMap.get(data.info.status)
    detail.value.status = data.info.status
    detail.value.titleColor = statusInfoMap.get(data.info.status).color
    detail.value.headerInfo = data.orders
    if (data.deliver_info) {
      detail.value.deliver_info.img = data.deliver_info.img.map((_) => _.url)
      detail.value.currentImg = detail.value.deliver_info.img
    }
    detail.value.orderInfo.sn = data.info.order_no
    detail.value.orderInfo.creatTime = data.info.created_at
    if (data.info.status === 50) {
      detail.value.orderInfo.finishTime = data.info.cancel_time
      detail.value.titleTip = data.info.cancel_reason
    } else {
      detail.value.orderInfo.finishTime = data.info.over_time
    }
    detail.value.orderInfo.is_assess_auth = data.info.is_assess_auth
    detail.value.hasAssessInfo = data.assess_info !== null
    Toast.clear()
  } catch (e) {
    Toast.fail(e)
    console.log(e)
  }
}
async function confirmHandler() {
  await Dialog.confirm({
    message: '工程师已完成全部服务？',
    confirmButtonColor: '#03BA78',
  })
    .then(async () => {
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      await confirmOrder({ order_no: Route.query.order_no as string })
      Toast.success('确认服务完成！')
      await initData()
    })
    .catch((e) => {
      // on cancel
      commonErrorHandle(e)
    })
}
function evaluationHanlder(type: string) {
  Router.push({
    name: 'delivery-service-evaluation',
    query: {
      type,
      order_no: Route.query.order_no as string,
    },
  })
}

onBeforeMount(async () => {
  await initData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "status-tag",
        style: _normalizeStyle({ color: _unref(detail).titleColor })
      }, [
        _createElementVNode("div", null, _toDisplayString(_unref(detail).title), 1),
        (_unref(isShowTitleTip))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(detail).titleTip), 1))
          : _createCommentVNode("", true)
      ], 4),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detail).headerInfo, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item-one-content-item",
              key: index,
              style: _normalizeStyle({ marginBottom: index > 0 ? '8px' : 0 })
            }, [
              _createElementVNode("img", {
                width: "48",
                height: "48",
                src: item.pic_path,
                onClick: ($event: any) => (showImg('header', 0, [item.pic_path]))
              }, null, 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(`x ${item.cnt}`), 1)
              ])
            ], 4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(Steps), { direction: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Step), null, {
                "active-icon": _withCtx(() => [
                  _hoisted_14
                ]),
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_unref(Step), null, {
                "active-icon": _withCtx(() => [
                  _hoisted_16
                ]),
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode(_unref(Step), null, {
                "active-icon": _withCtx(() => [
                  _hoisted_18
                ]),
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_unref(Step), null, {
                "active-icon": _withCtx(() => [
                  _hoisted_20
                ]),
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }),
              _createVNode(_unref(Step), null, {
                "active-icon": _withCtx(() => [
                  _hoisted_22
                ]),
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }),
              _createVNode(_unref(Step), null, {
                "active-icon": _withCtx(() => [
                  _hoisted_24
                ]),
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }),
              _createVNode(_unref(Step), null, {
                "active-icon": _withCtx(() => [
                  _hoisted_26
                ]),
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              }),
              _createVNode(_unref(Step), null, {
                "active-icon": _withCtx(() => [
                  _hoisted_28
                ]),
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      (_unref(isShowDeliverInfo))
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detail).deliver_info.img, (item, index) => {
                return (_openBlock(), _createElementBlock("img", {
                  width: "76",
                  height: "76",
                  src: item,
                  key: index,
                  onClick: () => showImg('pay', index)
                }, null, 8, _hoisted_32))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(detail).orderInfo.sn), 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(detail).orderInfo.creatTime), 1)
          ]),
          (_unref(isShowFinishTime))
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(detail).orderInfo.finishTime), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512),
    (_unref(isShowOperator))
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          (_unref(isShowFinish))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                class: "confirm-button",
                onClick: confirmHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认服务完成")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isShowEvaluation))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                class: "confirm-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (evaluationHanlder('edit')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("评价")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isShowViewEvaluation))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 2,
                class: "confirm-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (evaluationHanlder('detail')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看评价")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})